import { useEffect, useState, useRef, useCallback } from "react";
import IPDCFinalTable from "../../../../../../components/IPDCFinalTable";
import { Box, Button,CircularProgress,DialogContent,Dialog } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import { UpdateAndGetResponse, GetDataFromApiWithParams } from "../../../../../../services/api/ExecuteApiRequests";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PlanPrintPreview2 from "../../../MasterPlanandLandBankView/Forms/PlanPrintPreview2"; // Adjust the import path as needed
import MapDataProvider from "../../MapRelated/MapData/MapDataProvider";


export default function UnapprovedPlanRequests() {
  const [unapprovedPlanRequests, setUnapprovedPlanRequests] = useState([]);
  const componentRef = useRef();
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingRows, setLoadingRows] = useState({});
  const [openPreview, setOpenPreview] = useState(false);
  const [selectedFeature, setSelectedFeature] = useState(null);
  const [selectedInvestorName, setSelectedInvestorName] = useState("");
  const [selectedParkName, setSelectedParkName] = useState("");
  const [loadingGeometry, setLoadingGeometry] = useState(false);

  // Utility: convert nested objects to strings
  const stringifyNestedObjects = (dataArray) => {
    if (!dataArray || !Array.isArray(dataArray)) return [];
    
    return dataArray.map(item => {
      const newItem = {};
      Object.keys(item).forEach(key => {
        newItem[key] = (typeof item[key] === "object" && item[key] !== null)
          ? JSON.stringify(item[key])
          : item[key];
      });
      return newItem;
    });
  };

  // Handle view plan - fetch parcel data first then open preview
  const handleViewPlan = async (row) => {
    console.log("Viewing plan request:", row);
    
    setLoadingGeometry(true);
    
    try {
      // Fetch the full parcel data with geometry based on UPIN
      const parcelData = await GetDataFromApiWithParams(`parcels/${row.upin}`);
      console.log("KKKKKKKKKKKKKKKKK",parcelData )
      if (parcelData && parcelData[0].geometry) {
        setSelectedFeature(parcelData);
        setSelectedInvestorName(row.tenant_id || "Investor name not stated");
       
        setSelectedParkName(row.park_id || "Park name not stated");

        setOpenPreview(true);
      } else {
        toast.error("No geometry data available for this parcel", {
          position: "top-right",
          autoClose: 5000,
        });
      }
    } catch (error) {
      console.error("Error fetching parcel data:", error);
      toast.error("Failed to load parcel data. Please try again.", {
        position: "top-right",
        autoClose: 5000,
      });
    } finally {
      setLoadingGeometry(false);
    }
  };

  // Handle close preview
  const handleClosePreview = () => {
    setOpenPreview(false);
    setTimeout(() => {
      setSelectedFeature(null);
      setSelectedInvestorName("");
    }, 300);
  };

  // Handle print (if needed)
  const handlePrint = async () => {
    console.log("Printing plan...");
  };

  

  // Add action columns for Plan Requests - view, verify, and decline buttons
  const addActionColumns = useCallback((dataArray) => {
    if (!dataArray || !Array.isArray(dataArray)) return [];
    
    return dataArray.map(item => {
      const { attachments, ...itemWithoutAttachments } = item;
      return {
        ...itemWithoutAttachments,
        viewPlan: (
          <Button 
            variant="outlined" 
            size="small"
            startIcon={<VisibilityIcon />}
            onClick={() => handleViewPlan(itemWithoutAttachments)}
            sx={{ 
              whiteSpace: 'nowrap', 
              minWidth: '100px',
              color: '#1976d2',
              borderColor: '#1976d2',
              '&:hover': {
                backgroundColor: '#e3f2fd',
                borderColor: '#1565c0',
              }
            }}
          >
            View Plan
          </Button>
        ),
        verify: (
          <Button 
            variant="contained" 
            size="small"
            onClick={() => handleApprove(itemWithoutAttachments)}
            disabled={loadingRows[item.id] === 'approve'}
            sx={{ 
              whiteSpace: 'nowrap', 
              minWidth: '80px',
              bgcolor: '#f5f5f5',
              color: '#000',
              '&:hover': {
                bgcolor: '#e0e0e0',
              }
            }}
          >
            {loadingRows[item.id] === 'approve' ? "Processing..." : "Verify"}
          </Button>
        ),
        decline: (
          <Button 
            variant="contained" 
            size="small"
            onClick={() => handleDecline(itemWithoutAttachments)}
            disabled={loadingRows[item.id] === 'decline'}
            sx={{ 
              whiteSpace: 'nowrap', 
              minWidth: '80px',
              backgroundColor: '#f5f5f5',
              color: '#d32f2f',
              '&:hover': {
                backgroundColor: '#e0e0e0',
                color: '#b71c1c',
              },
              '&:disabled': {
                backgroundColor: '#f5f5f5',
                color: '#d32f2f',
                opacity: 0.6,
              }
            }}
          >
            {loadingRows[item.id] === 'decline' ? "Processing..." : "Decline"}
          </Button>
        )
      };
    });
  }, [loadingRows]);

  // Handle approve plan request
  const handleApprove = async (row) => {
    console.log("kkkkkkkkkkkkkkkkkkkk", row.upin)
    setLoadingRows(prev => ({ ...prev, [row.id]: 'approve' }));
    try {
      const result = await UpdateAndGetResponse(`investorplanrequests/${row.upin}/approve`);
      console.log("KAKAKAKAKAKAK", result)
      if (result ) {
        toast.success("Plan request verified successfully!", { 
          position: "top-right",
          autoClose: 8000,
          pauseOnHover: true,
          closeOnClick: false
        });

        setUnapprovedPlanRequests(prevData => 
          prevData.filter(item => item.id !== row.id)
        );
      } else {
        toast.error("Failed to verify plan request! Please try again.", { 
          position: "top-right",
          autoClose: 8000,
          pauseOnHover: true,
          closeOnClick: false
        });
      }
    } catch (error) {
      console.error("Error approving plan request:", error);
      toast.error("Failed to verify plan request! Please try again.", { 
        position: "top-right",
        autoClose: 8000,
        pauseOnHover: true,
        closeOnClick: false
      });
    } finally {
      setLoadingRows(prev => ({ ...prev, [row.id]: null }));
    }
  };

  // Handle decline plan request
  const handleDecline = async (row) => {
    setLoadingRows(prev => ({ ...prev, [row.id]: 'decline' }));
    try {
      const result = await UpdateAndGetResponse(`investorplanrequests/decline/${row.upin}/decline`);
      
      if (result && result.success) {
        toast.success("Plan request declined successfully!", { 
          position: "top-right",
          autoClose: 8000,
          pauseOnHover: true,
          closeOnClick: false
        });

        setUnapprovedPlanRequests(prevData => 
          prevData.filter(item => item.id !== row.id)
        );
      } else {
        toast.error("Failed to decline plan request! Please try again.", { 
          position: "top-right",
          autoClose: 8000,
          pauseOnHover: true,
          closeOnClick: false
        });
      }
    } catch (error) {
      console.error("Error declining plan request:", error);
      toast.error("Failed to decline plan request! Please try again.", { 
        position: "top-right",
        autoClose: 8000,
        pauseOnHover: true,
        closeOnClick: false
      });
    } finally {
      setLoadingRows(prev => ({ ...prev, [row.id]: null }));
    }
  };

  useEffect(() => {
    const fetchPlanRequests = async () => {
      setLoading(true);
      
      try {
        const result = await GetDataFromApiWithParams("investorplanrequests/request");
        
        if (result && result.success && result.data && result.data.length > 0) {
          const formattedData = stringifyNestedObjects(result.data);
          const dataWithActions = addActionColumns(formattedData);
          setUnapprovedPlanRequests(dataWithActions);
          
          const baseColumns = dataWithActions.length > 0 
            ? Object.keys(dataWithActions[0]).filter(col => !['viewPlan', 'verify', 'decline'].includes(col))
            : [];
          
          const orderedColumns = [
            'tenant_id',
            'park_id', 
            'upin',
            'description',
            'request_date',
            'viewPlan',
            'verify',
            'decline'
          ];
          
          setSelectedColumns(orderedColumns);
          
          console.log("Ordered columns:", orderedColumns);
          console.log("Fetched unapproved plan requests:", dataWithActions);
        } else {
          console.log("No unapproved plan requests found");
          setUnapprovedPlanRequests([]);
          setSelectedColumns([]);
        }
      } catch (error) {
        console.error("Error fetching plan requests:", error);
        toast.error("Failed to load plan requests. Please try again.", {
          position: "top-right",
          autoClose: 8000
        });
      } finally {
        setLoading(false);
      }
    };

    fetchPlanRequests();
  }, [addActionColumns]);

  return (
    <MapDataProvider>
      <Box sx={{ p: 2 }}>
        <ToastContainer 
          position="top-right"
          autoClose={8000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        
        {loading ? (
          <div style={{ textAlign: 'center', padding: '20px' }}>Loading plan requests...</div>
        ) : (
          <>
            <div>
              <h3 style={{ marginBottom: '15px', color: '#333' }}>Unapproved Plan Requests</h3>
              
              {unapprovedPlanRequests.length > 0 ? (
                <IPDCFinalTable
                  ref={componentRef}
                  data={unapprovedPlanRequests}
                  setData={setUnapprovedPlanRequests}
                  selectedColumns={selectedColumns}
                  title="Unapproved Plan Requests"
                  attachmentLink=""
                  hasAttachment={false}
                />
              ) : (
                <div style={{ 
                  padding: '20px', 
                  backgroundColor: '#f5f5f5', 
                  borderRadius: '4px',
                  textAlign: 'center',
                  color: '#666'
                }}>
                  No plan requests to approve
                </div>
              )}
            </div>
          </>
        )}

        {/* Loading Dialog */}
        <Dialog open={loadingGeometry} maxWidth="xs">
          <DialogContent sx={{ textAlign: 'center', py: 4 }}>
            <CircularProgress />
            <Box sx={{ mt: 2 }}>Loading parcel data...</Box>
          </DialogContent>
        </Dialog>

        {/* Plan Print Preview Dialog */}
        {console.log("XXXXXXXXXXXXXXXXXXXXXXXXXX", selectedParkName)}
        {openPreview && selectedFeature && (
         
          <PlanPrintPreview2
            feature={selectedFeature}
            parkName={selectedParkName}
            investorName={selectedInvestorName}
            open={openPreview}
            onClose={handleClosePreview}
            onPrint={handlePrint}
          />
        )}
      </Box>
    </MapDataProvider>
  );
}